import { Variants, Transition } from 'framer-motion';

export const easeOut: Transition = { duration: 0.22, ease: [0.2, 0.8, 0.2, 1] };

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: easeOut },
};

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: easeOut },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: easeOut },
};

export const stagger = (delay = 0.04): Variants => ({
  hidden: {},
  visible: { transition: { staggerChildren: delay } },
});

export const slideInRight: Variants = {
  hidden: { opacity: 0, x: 24 },
  visible: { opacity: 1, x: 0, transition: easeOut },
  exit: { opacity: 0, x: 24, transition: easeOut },
};
